import { useMemo } from "react"
import { useTranslation } from "react-i18next";
import ResourceSelect from "../../../../../../components/Inputs/ResourceSelect";
import { renderSettingsResourceLabel } from "../../../../../../utils/helpers/settings";
import { getSettingsResourceSearchFilters } from "../../../../../../utils/helpers/settings";

export const useProjectFilter = () => {
    const { t } = useTranslation();

    return useMemo(() => ({
        name: "project",
        label: t("project"),
        type: "resource-select",
        component: (
            <ResourceSelect
                labelPropName="description"
                renderLabel={renderSettingsResourceLabel}
                resourcePath="/project"
                hasSearch
                mode="multiple"
                getSearchFilters={getSettingsResourceSearchFilters}
            />
        ),
    }), [t]);
}